import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "editor-text-italic-24", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "currentColor", strokeLinecap: "round", strokeWidth: 1.5 },
        React.createElement("path", { strokeLinejoin: "round", d: "m13.5 6-3 12" }),
        React.createElement("path", { d: "M11 5.75h5m-8 12.5h5" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
